import {Mixin} from "@/mixins";
import alert from "../../../../view/pages/vue-bootstrap/Alert";

const set = key => (state, val) => {
    state[key] = val
}

function initialState() {
    return {
        total: 0,
        query: {},
        roles: [],
        loading: false
    }
}

const route = 'categories'

const getters = {
    roles: state => state.roles,
    total: state => state.total,
    loading: state => state.loading
}

const actions = {
    fetchIndexData({ commit, state }) {
        commit('setLoading', true)

        Mixin.methods.requestApiGet('admin/roles',state.query)
            .then(response => {
                commit('setRoles', response.data.data)
                commit('setTotal', response.data.total)
            })
            .catch(error => {
                window.alert(error)
                ;
                // message = error.response.data.message || error.message
                // TODO error handling
            })
            .finally(() => {
                commit('setLoading', false)
            })




    },
    destroyData({ commit, state, dispatch }, id) {
        axios
            .delete(`${route}/${id}`)
            .then(response => {
                dispatch('fetchIndexData')
            })
            .catch(error => {
                message = error.response.data.message || error.message
                // TODO error handling
            })
    },
    setQuery({ commit }, value) {
        commit('setQuery', _.cloneDeep(value))
    },
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setRoles: set('roles'),
    setTotal: set('total'),
    setQuery(state, query) {
        query.page = (query.offset + query.limit) / query.limit
        state.query = query
    },
    setLoading: set('loading'),
    resetState(state) {
        Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
